import { inject, isDevMode } from '@angular/core';
import { Functions, httpsCallable } from '@fido/firebase/functions';
import { createInjectionToken } from 'ngxtension/create-injection-token';
import { ConflictMatchSchema } from 'fido-types';
import { z } from 'zod';

// ── Response schema ───────────────────────────────────────────────────────────
// Mirrors SearchContactsResult from functions/src/conflict/search-contacts.ts.
// Validated client-side to catch unexpected CF response shapes early.

export const SearchContactsResultSchema = z.object({
  matches: z.array(ConflictMatchSchema),
  totalRecordsSearched: z.number(),
  queryType: z.enum(['email', 'phone', 'name']),
});

export type SearchContactsResult = z.infer<typeof SearchContactsResultSchema>;

// ── Injection token ───────────────────────────────────────────────────────────

export const [injectSearchContacts, provideSearchContacts] = createInjectionToken(() => {
  const functions = inject(Functions);
  return async (organizationId: string, query: string): Promise<SearchContactsResult> => {
    try {
      const response = await httpsCallable(functions, 'searchContacts')({ organizationId, query });
      return SearchContactsResultSchema.parse(response.data);
    } catch (e) {
      if (isDevMode()) console.error('searchContacts error:', e);
      throw e; // re-throw; component classifies by FirebaseError code
    }
  };
});
